import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

export default function TinymceFloatPanel (props) {
  const { children, menuRef, handleKeyDownOnMenu } = props;

  const [initialized, setInitialized] = useState(false);
  useEffect(() => setInitialized(true), [initialized]);

  return (
    <div className={classnames('mce-container mce-panel mce-floatpanel mce-menu mce-animate mce-fixed mce-menu-align', { 'mce-in': initialized })} role="application">
      <div ref={menuRef} onKeyDown={handleKeyDownOnMenu} className="mce-container-body mce-stack-layout" role="menu">
        { children }
      </div>
    </div>
  );
}
